import { makeObservable, observable, runInAction, action } from 'mobx';
import StoreUtils from './store-utils';

class ContentStore {
  linkId = '';
  contentIds = [];  // List to store multiple content IDs
  handoutData = [];
  lastUpdated = 0;
  db;
  isInitialized = false;

  constructor(uniqueId) {
    this.db = StoreUtils.createDexieUserDB(uniqueId, 'ContentStore');
    this.db.version(2).stores({
      content: '&id'  // '&id' indicates that 'id' is a primary key
    });

    makeObservable(this, {
      linkId: observable,
      contentIds: observable,
      handoutData: observable,
      lastUpdated: observable,
      isInitialized: observable,
      initializeAsync: action,
      updateContent: action,
      clearStore: action,
      deleteDatabase: action
    });
  }

  async initializeAsync() {
    const contents = await this.db.content.toArray();
    runInAction(() => {
      if (contents.length > 0) {
        this.linkId = contents[0].linkId; // Assume all share the same linkId
        this.contentIds = contents.map(item => item.contentId);
        this.handoutData = contents;
        this.lastUpdated = Math.max(...contents.map(item => item.lastUpdated));
      } else {
        console.log('No data found in IndexedDB');
      }
      this.isInitialized = true;
    });
  }

  async updateContent(linkId, handouts) {
    console.log(`ContentStore updateContent linkId: ${linkId}`);
    await this.db.transaction('rw', this.db.content, async () => {
      await this.db.content.clear(); // Clear old content
      for (const handout of handouts) {
        const dataForDb = {
          id: handout.contentId, // Use contentId as the unique key
          linkId: linkId,
          contentId: handout.contentId,
          ...handout,  // Spread all properties of handout directly into the object to be stored
          lastUpdated: new Date().getTime()
        };
        await this.db.content.put(dataForDb);
      }
    });
    runInAction(() => {
      this.linkId = linkId;
      this.handoutData = handouts; // Directly use the fetched array
      this.lastUpdated = new Date().getTime();  // Update to the most recent update time
    });
  }
  

  async clearStore() {
    await this.db.content.clear();
    runInAction(() => {
      this.linkId = '';
      this.contentIds = [];
      this.handoutData = [];
      this.lastUpdated = 0;
    });
  }

  async deleteDatabase() {
    await this.db.delete();
    runInAction(() => {
      this.isInitialized = false;
      this.linkId = '';
      this.contentIds = [];
      this.handoutData = [];
      this.lastUpdated = 0;
    });
  }
}

const createContentStore = async (uniqueId) => {
  const store = new ContentStore(uniqueId);
  await store.initializeAsync();
  return store;
};

export default createContentStore;
